// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.font[data-v-0b1747f1] {\n    font-family: 'Poppins';\n}\n.custom-link[data-v-0b1747f1]:hover {\n    text-decoration: underline;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
